import "core-js/modules/web.dom-collections.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
const {
  useCallback,
  useEffect,
  useRef,
  useReducer
} = React;

const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'loading'
      });

    case 'completed':
      const {
        results
      } = action.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'completed',
        results
      });

    case 'error':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'error',
        results: []
      });

    case 'query':
      const {
        queryString
      } = action.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        queryString
      });

    default:
      return state;
  }
};

const useSearch = query => {
  const canHandle = useRef(false);
  const initialState = {
    queryString: '',
    results: [],
    status: 'initial'
  }; // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.

  const [state, dispatch] = useReducer(reducer, initialState);
  const onChangeQuery = useCallback(value => {
    // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
    dispatch({
      type: 'query',
      payload: {
        queryString: value
      }
    });
  }, []);
  const {
    queryString,
    results,
    status
  } = state;
  useEffect(() => {
    canHandle.current = true; // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.

    dispatch({
      type: 'loading'
    });
    query(queryString).then(results => {
      if (canHandle.current) {
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
          type: 'completed',
          payload: {
            results
          }
        });
      }
    }, reason => {
      if (canHandle.current) {
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
          type: 'error'
        });
      }
    });
    return () => {
      canHandle.current = false;
    };
  }, [query, queryString]);
  return {
    onChangeQuery,
    queryString,
    results,
    status
  };
};

export default useSearch;